import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=144aefbc&scoped=true&"
import script from "./textarea.vue?vue&type=script&lang=js&"
export * from "./textarea.vue?vue&type=script&lang=js&"
import style0 from "./textarea.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./textarea.vue?vue&type=style&index=1&id=144aefbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144aefbc",
  null
  
)

export default component.exports